// Copyright (c) 2024 Deere & Company

import ResponsibleDealerReport from '@deere/cps-it.warranty-model-factory/lib/responsible-dealer-report';
import t from 'tcomb';

const Report = t.list(ResponsibleDealerReport, 'Report');

export const getDefaultState = () => new Report([]);

export default Report;



// WEBPACK FOOTER //
// ./src/reports/responsible-dealer/state/report.js